import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { normalizeAnalysisSearch, type AnalysisSearch } from '@/lib/route-search';
import { TrafficPage } from '@/components/analysis/TrafficPage';
import { SearchPage } from '@/components/analysis/SearchPage';
import { SeoPage } from '@/components/analysis/SeoPage';

export const Route = createFileRoute('/analysis')({
  validateSearch: normalizeAnalysisSearch,
  component: AnalysisPage,
});

// 탭 UI는 사이드바로 승격됨 — 이 라우트는 tab 파라미터에 따른 배선만 담당
function AnalysisPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/analysis' });

  function updateSearch(patch: Partial<AnalysisSearch>, replace = true) {
    void navigate({
      search: previous => normalizeAnalysisSearch({ ...previous, ...patch }),
      replace,
    });
  }

  if (search.tab === 'search') {
    return <SearchPage days={search.searchDays} onDaysChange={searchDays => updateSearch({ searchDays })} />;
  }
  if (search.tab === 'seo') {
    return <SeoPage filter={search.seoFilter} onFilterChange={seoFilter => updateSearch({ seoFilter })} />;
  }
  return <TrafficPage days={search.trafficDays} onDaysChange={trafficDays => updateSearch({ trafficDays })} />;
}
